import {AppFunction} from "../misc/types";
import View from "../framework/view";
import PractichordView from "../views/practichord";

export class PractichordFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new PractichordView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/practichord`;
    }

}
